import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import { isEqual } from "lodash";
import MerchandiserInvoicingStatuses from "data/merchandiser-invoicing-statuses";
import sortObject from "functions/sort-object";
import UserTypes from "components/auth/user-types";
import SearchSelect from "components/common/SearchSelect";
import {
    fetchAccountManagers,
    clearAccountManagers,
    fetchMerchandisers,
} from "actions/employeeActions";
import {
    fetchMerchandiserInvoicingJobs,
} from "api/menu/invoicing/actions";
import moment from "moment";

class ListChargesHeader extends Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.statusesArray = Object.keys(MerchandiserInvoicingStatuses)
            .map(key => ({
                label: MerchandiserInvoicingStatuses[key].title,
                value: MerchandiserInvoicingStatuses[key].value
            }));

        this.state = {
            ...this.props.filters,

            status: this.props.userRole.includes(UserTypes.accountManager) ||
                this.props.userRole.includes(UserTypes.admin) ?
                this.statusesArray.find(x => x.label === "Not Approved Yet") :
                this.statusesArray.find(x => x.label === "All Charges"),

            merchandisersOptions: [],
            accountManagerOptions: [],
            jobOptions: this.props.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
            })),
        };

        const isAdminView = this.props.userRole.includes(UserTypes.admin);
        const isAccountManagerView = this.props.userRole.includes(UserTypes.accountManager);
        if (isAdminView || isAccountManagerView) {
            this.props.fetchAccountManagers();
            this.props.fetchMerchandisers();
        }
        this.props.fetchMerchandiserInvoicingJobs();
    }

    componentWillReceiveProps(nextProps) {
        const newState = {};
        if (!isEqual(nextProps.filters, this.props.filters)) {
            Object.keys(nextProps.filters)
                .forEach(key => {
                    newState[key] = nextProps.filters[key];
                });
        }
        if (Array.isArray(nextProps.accountManagers) && nextProps.accountManagers.length > 0) {
            newState.accountManagerOptions = [];
            const isEmptyNextPropsAccountManagers = Array.isArray(nextProps.accountManagers) &&
                nextProps.accountManagers.length === 0;
            // const isEmptyCurrentAccountManagers = Array.isArray(this.props.accountManagers) &&
            //     this.props.accountManagers.length === 0;
            // if (isEmptyNextPropsAccountManagers && isEmptyCurrentAccountManagers) {
            //     this.props.fetchAccountManagers();
            //     this.props.fetchMerchandisers();
            //     return;
            // }

            const currentAccountManagers = isEmptyNextPropsAccountManagers ? this.props.accountManagers : nextProps.accountManagers;
            // eslint-disable-next-line max-len
            sortObject(currentAccountManagers,
                Object.keys(currentAccountManagers)
                    .map((value) => parseInt(value, 10)),
                "lastName",
                true)
                .forEach(index => {
                    newState.accountManagerOptions.push({
                        value: currentAccountManagers[index].id,
                        label: currentAccountManagers[index].name
                    });
                });
        }

        if (Array.isArray(nextProps.merchandisers) && nextProps.merchandisers.length > 0) {
            newState.merchandisersOptions = [];
            sortObject(
                nextProps.merchandisers,
                Object.keys(nextProps.merchandisers)
                    .map((value) => parseInt(value, 10)),
                "lastName",
                true
            )
                .forEach(index => {
                    newState.merchandisersOptions.push({
                        value: nextProps.merchandisers[index].id,
                        label: nextProps.merchandisers[index].name
                    });
                });
        }

        if (!isEqual(nextProps.jobs, this.props.jobs)) {
            newState.jobOptions = nextProps.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
            }));
        }

        if (Object.keys(newState).length) {
            this.setState(newState);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (!isEqual(nextProps.accountManagers, this.props.accountManagers)) {
            return true;
        } else if (!isEqual(nextProps.merchandisers, this.props.merchandisers)) {
            return true;
        } else if (!isEqual(nextProps.jobs, this.props.jobs)) {
            return true;
        } else if (!isEqual(nextProps.filters, this.props.filters)) {
            return true;
        } else if (!isEqual(nextProps.submitIsDisabled, this.props.submitIsDisabled)) {
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        this.props.clearAccountManagers();
        this.props.fetchMerchandisers(true);
    }

    render() {
        const { userRole } = this.props;
        const {
            fromDate,
            toDate,
            jobId,
            status,
            manualEntryOnly,
            accountManagerId,
            accountManagerOptions,
            merchandiserId,
            merchandisersOptions,
            jobOptions,
        } = this.state;
        const isAdminView = userRole.includes(UserTypes.admin);
        const isAccountManagerView = userRole.includes(UserTypes.accountManager);

        return (
            <div className="row pt-1 pb-3">
                {(isAdminView || isAccountManagerView) ?
                    <div className="col-2">
                        <div className="form-group mb-0">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                Account Manager
                            </label>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={true}
                                isSearchable={true}
                                options={accountManagerOptions}
                                value={accountManagerId}
                                onChange={(option) => this.props.handleSelect("accountManagerId", option)}
                            />
                        </div>
                        <div className="form-group mb-0">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                Merchandiser
                            </label>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={true}
                                isSearchable={true}
                                options={merchandisersOptions}
                                value={merchandiserId}
                                onChange={(option) => this.props.handleSelect("merchandiserId", option)}
                            />
                        </div>
                    </div>
                    : null}
                <div className="col-2">
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            Job
                        </label>
                        <SearchSelect
                            className="custom-react-select"
                            isLoading={false}
                            isClearable={true}
                            isSearchable={true}
                            options={jobOptions}
                            value={jobId}
                            onChange={(option) => this.props.handleSelect("jobId", option)}
                        />
                    </div>
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            Status
                        </label>
                        <SearchSelect
                            className="custom-react-select"
                            isLoading={false}
                            isClearable={false}
                            isSearchable={true}
                            options={this.statusesArray}
                            value={status}
                            onChange={(option) => this.props.handleSelect("status", option)}
                        />
                    </div>
                </div>
                <div className="col-2">
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            From Date
                        </label>
                        <DatePicker
                            value={fromDate}
                            format={this.dateFormat}
                            onChange={date => this.props.handleSelect("fromDate", date)}
                            className="d-block"
                            disabledDate={(current) => {
                                if (isAdminView) {
                                    return false;
                                }
                                return current && current < moment()
                                    .subtract(90, "days");
                            }}
                        />
                    </div>
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            To Date
                        </label>
                        <DatePicker
                            value={toDate}
                            format={this.dateFormat}
                            onChange={date => this.props.handleSelect("toDate", date)}
                            className="d-block"
                        />
                    </div>
                </div>
                <div className="col-2 d-flex flex-column justify-content-end">
                    {isAdminView ?
                        <div className="custom-control custom-checkbox mb-4">
                            <input
                                id="manualEntryOnly"
                                type="checkbox"
                                checked={manualEntryOnly}
                                className="custom-control-input"
                                onChange={() => this.props.handleSelect("manualEntryOnly", !manualEntryOnly)}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="manualEntryOnly"
                            >
                                Manual Entry Only
                            </label>
                        </div>
                        : null}
                    <button
                        className="btn btn-primary"
                        onClick={() => this.props.handleLoad()}
                    >
                        Load
                    </button>
                </div>
                <div className="col-2 d-flex flex-column justify-content-end">
                    <button
                        className="btn btn-warning"
                        onClick={this.props.handleViewPreliminaryInvoice}
                    >
                        View Preliminary Invoice
                    </button>
                    {isAdminView || isAccountManagerView ?
                        <button
                            className="btn btn-info mt-4"
                            onClick={this.props.handleApprove}
                        >
                            Approve selected
                        </button>
                        : null}
                </div>
                <div className="col-2 d-flex flex-column justify-content-end">
                    <button
                        className="btn btn-success"
                        onClick={this.props.handleSubmitInvoice}
                        disabled={this.props.submitIsDisabled}
                    >
                        Submit Invoice
                    </button>
                </div>
            </div>
        );
    }
}

ListChargesHeader.propTypes = {
    handleLoad: PropTypes.func.isRequired,
    handleViewPreliminaryInvoice: PropTypes.func.isRequired,
    handleSelect: PropTypes.func.isRequired,
    handleApprove: PropTypes.func.isRequired,
    handleSubmitInvoice: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    userRole: state.auth.user.role,
    accountManagers: state.employee.accountManagers,
    merchandisers: state.employee.merchandisers,
    jobs: state.invoicing.jobs,
});

const mapStateToDispatch = dispatch => ({
    fetchMerchandiserInvoicingJobs: bindActionCreators(fetchMerchandiserInvoicingJobs, dispatch),
    fetchMerchandisers: bindActionCreators(fetchMerchandisers, dispatch),
    fetchAccountManagers: bindActionCreators(fetchAccountManagers, dispatch),
    clearAccountManagers: bindActionCreators(clearAccountManagers, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ListChargesHeader);
